/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Set_Color_MagentaInputs */



/**
* | output |
* | --- |
* | "Set Color Magenta" |
*
* @param {Shortcut_Keys_Name_Set_Color_MagentaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_set_color_magenta = /** @type {((inputs?: Shortcut_Keys_Name_Set_Color_MagentaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Set_Color_MagentaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Set Color Magenta")
	if (locale === "de") return /** @type {LocalizedString} */ ("Set Color Magenta")
	if (locale === "it") return /** @type {LocalizedString} */ ("Set Color Magenta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Set Color Magenta")
	if (locale === "es") return /** @type {LocalizedString} */ ("Set Color Magenta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Set Color Magenta")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Set Color Magenta")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Set Color Magenta")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Set Color Magenta")
	return /** @type {LocalizedString} */ ("Set Color Magenta")
});